{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Przekroczono limit rozmów. Plan Hacker pozwala tylko na 500 rozmów.",
      "INBOXES": "Przekroczono limit skrzynek odbiorczych. Plan Hacker obsługuje tylko live-chat. Dodatkowe skrzynki (e-mail, WhatsApp itp.) wymagają planu płatnego.",
      "AGENTS": "Przekroczono limit agentów. Plan Hacker pozwala tylko na 2 agentów.",
      "NON_ADMIN": "Skontaktuj się z administratorem, aby uaktualnić plan i nadal korzystać ze wszystkich funkcji."
    },
    "TITLE": "Ustawienia konta",
    "SUBMIT": "Zaktualizuj ustawienia",
    "BACK": "Powrót",
    "DISMISS": "Odrzuć",
    "UPDATE": {
      "ERROR": "Nie udało się zaktualizować ustawień, spróbuj ponownie!",
      "SUCCESS": "Ustawienia konta zostały pomyślnie zaktualizowane"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Usuń swoje konto",
      "NOTE": "Po usunięciu konta wszystkie Twoje dane zostaną usunięte.",
      "BUTTON_TEXT": "Usuń swoje konto",
      "CONFIRM": {
        "TITLE": "Usuń konto",
        "MESSAGE": "Usunięcie konta jest nieodwracalne. Wpisz nazwę konta poniżej, aby potwierdzić trwałe usunięcie.",
        "BUTTON_TEXT": "Usuń",
        "DISMISS": "Anuluj",
        "PLACE_HOLDER": "Wpisz {accountName}, aby potwierdzić"
      },
      "SUCCESS": "Konto oznaczone do usunięcia",
      "FAILURE": "Nie można usunąć konta, spróbuj ponownie!",
      "SCHEDULED_DELETION": {
        "TITLE": "Konto zaplanowane do usunięcia",
        "MESSAGE_MANUAL": "To konto jest zaplanowane do usunięcia w dniu {deletionDate}. Zostało to zażądane przez administratora. Możesz anulować usunięcie przed tą datą.",
        "MESSAGE_INACTIVITY": "To konto jest zaplanowane do usunięcia w dniu {deletionDate} z powodu nieaktywności konta. Możesz anulować usunięcie przed tą datą.",
        "CLEAR_BUTTON": "Anuluj zaplanowane usunięcie"
      }
    },
    "FORM": {
      "ERROR": "Proszę poprawić błędy formularza",
      "GENERAL_SECTION": {
        "TITLE": "Ustawienia ogólne",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID konta",
        "NOTE": "To ID jest wymagane, jeśli tworzysz integrację opartą na API"
      },
      "NAME": {
        "LABEL": "Nazwa konta",
        "PLACEHOLDER": "Nazwa konta",
        "ERROR": "Wprowadź poprawną nazwę konta"
      },
      "LANGUAGE": {
        "LABEL": "Język strony",
        "PLACEHOLDER": "Język konta",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Domena przychodzących wiadomości e-mail",
        "PLACEHOLDER": "Domena, na której otrzymujesz wiadomości e-mail",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-mail obsługi",
        "PLACEHOLDER": "E-mail obsługi klienta Twojej firmy",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Liczba dni po upływie których rozmowa powinna zostać automatycznie zamknięta z powodu braku aktywności",
        "NOTE": "Liczba godzin nieaktywności, po których każda otwarta rozmowa zostanie automatycznie zamknięta.",
        "PLACEHOLDER": "30",
        "ERROR": "Wprowadź poprawną wartość dla czasu automatycznego zamykania rozmów (minimum 1 dzień, maksimum 999 dni)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Liczba dni, po których pusta rozmowa powinna zostać automatycznie zamknięta w przypadku braku aktywności",
        "PLACEHOLDER": "nigdy",
        "ERROR": "Wprowadź prawidłowy czas automatycznego zamknięcia pustej rozmowy (min. 1, maks. 999 dni)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Kontynuacja rozmów za pomocą wiadomości e-mail jest włączona dla Twojego konta.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Możesz teraz odbierać wiadomości e-mail na swojej własnej domenie."
      },
      "PHONE": {
        "TITLE": "Ustawienia PBX",
        "NOTE": "Skonfiguruj połączenie z PBX dla połączeń telefonicznych",
        "SIP_HOST": {
          "LABEL": "Domena SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Tryb wybierania",
          "MODES": {
            "direct": "Bezpośredni - połączenie jest wybierane natychmiast po kliknięciu linku telefonicznego",
            "indirect": "Pośredni - numer telefonu jest przygotowywany w polu widgetu telefonu"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Dostęp do nagrań połączeń",
          "MODES": {
            "admin_only": "Tylko administratorzy",
            "admin_and_assigned_agent": "Administratorzy i przypisany agent",
            "inbox_members": "Wszyscy agenci z dostępem do skrzynki"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Ustawienia e-mail",
        "NOTE": "Zmienia zachowanie skrzynek e-mail"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Tryb wyświetlania znacznika czasu rozmowy",
        "MODES": {
          "both": "Utworzona i ostatnia aktywność",
          "last_activity_only": "Tylko ostatnia aktywność",
          "last_customer_message": "Ostatnia wiadomość klienta"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blokuj domeny o niskiej reputacji"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Dołącz oryginalną wiadomość w odpowiedzi na e-mail"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Automatycznie zamykaj nową rozmowę"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Automatycznie przenoś nową rozmowę e-mail do skrzynki robota, który obsłużył zamówienia kontaktu"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Rozszerzone etykiety - zezwalaj na dłuższe nazwy etykiet z większym interfejsem wyskakującym"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - automatycznie przypisuj rozmowę do agenta, który udzielił ostatniej odpowiedzi"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Tryb powiadomień push",
        "MODES": {
          "all_inboxes": "Wszystkie skrzynki - wysyłaj powiadomienia dla wszystkich typów kanałów",
          "chat_only": "Tylko czat - wysyłaj powiadomienia tylko dla kanałów innych niż e-mail"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Zezwalaj na przełączanie podpisu dla wysyłanych wiadomości"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Wyświetl status czatu agenta na wallboardzie"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Pokazuj pełne nazwy załączników bez skracania"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Logowanie hasłem",
        "MODES": {
          "allowed_for_all": "Dozwolone dla wszystkich użytkowników",
          "allowed_for_agents_only": "Dozwolone tylko dla agentów (administratorzy muszą używać OAuth)",
          "password_login_disabled": "Wyłączone - tylko OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Dostępna jest nowa wersja. Przeładuj stronę, aby pobrać najnowsze aktualizacje.",
    "RELOAD_NOW": "Aktualizuj teraz",
    "LEARN_MORE": "Dowiedz się więcej",
    "PAYMENT_PENDING": "Twoja płatność jest w toku. Zaktualizuj informacje o płatności, aby kontynuować korzystanie z oprogramowania.",
    "LIMITS_UPGRADE": "Twoje konto przekroczyło limit użytkowania. Zaktualizuj swój plan, aby kontynuować korzystanie z oprogramowania.",
    "OPEN_BILLING": "Otwórz fakturę"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Naciśnij Enter, aby wybrać",
      "ENTER_TO_REMOVE": "Naciśnij Enter, aby usunąć",
      "NO_OPTIONS": "Lista jest pusta",
      "NO_RESULT": "Nie znaleziono wyników",
      "SELECT_ONE": "Wybierz jeden",
      "SELECT": "Wybierz"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Powiadomienia",
    "MARK_ALL_DONE": "Oznacz wszystkie jako zrobione",
    "DELETE_TITLE": "usunięto",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Nieprzeczytane powiadomienia",
      "ALL_NOTIFICATIONS": "Wyświetl wszystkie powiadomienia",
      "LOADING_UNREAD_MESSAGE": "Ładowanie nieprzeczytanych powiadomień...",
      "EMPTY_MESSAGE": "Nie masz żadnych nieprzeczytanych powiadomień"
    },
    "LIST": {
      "LOADING_MESSAGE": "Ładowanie powiadomień...",
      "404": "Nie znaleziono powiadomień",
      "TABLE_HEADER": [
        "Nazwisko",
        "Numer telefonu",
        "Rozmowy",
        "Ostatni kontakt"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nowa rozmowa",
      "conversation_assignment": "Przypisanie rozmowy",
      "assigned_conversation_new_message": "Nowa wiadomość",
      "participating_conversation_new_message": "Nowa wiadomość",
      "conversation_mention": "Wzmianka",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Niedostępny",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Odśwież"
    },
    "CONNECTION_LOST": {
      "TITLE": "Utracono połączenie",
      "DESCRIPTION": "Nie udało się połączyć z serwerem. Sprawdź połączenie i spróbuj ponownie.",
      "RETRY": "Spróbuj ponownie"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Szukaj lub przejdź do",
    "SECTIONS": {
      "GENERAL": "Ogólne",
      "REPORTS": "Raporty",
      "CONVERSATION": "Rozmowa",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Zmień przypisanego",
      "CHANGE_PRIORITY": "Zmień priorytet",
      "CHANGE_TEAM": "Zmień zespół",
      "SNOOZE_CONVERSATION": "Zatrzymaj rozmowę",
      "EXECUTE_MACRO": "Uruchom makro",
      "ADD_LABEL": "Dodaj etykietę do rozmowy",
      "REMOVE_LABEL": "Usuń etykietę z rozmowy",
      "SETTINGS": "Ustawienia",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Przejdź do pulpitu rozmów",
      "GO_TO_CONTACTS_DASHBOARD": "Przejdź do pulpitu kontaktów",
      "GO_TO_REPORTS_OVERVIEW": "Przejdź do przeglądu raportów",
      "GO_TO_CONVERSATION_REPORTS": "Przejdź do raportów rozmów",
      "GO_TO_AGENT_REPORTS": "Przejdź do raportów agentów",
      "GO_TO_LABEL_REPORTS": "Przejdź do raportów etykiet",
      "GO_TO_INBOX_REPORTS": "Przejdź do raportów skrzynek odbiorczych",
      "GO_TO_TEAM_REPORTS": "Przejdź do raportów zespołów",
      "GO_TO_SETTINGS_AGENTS": "Przejdź do ustawień agentów",
      "GO_TO_SETTINGS_TEAMS": "Przejdź do ustawień zespołów",
      "GO_TO_SETTINGS_INBOXES": "Przejdź do ustawień skrzynek odbiorczych",
      "GO_TO_SETTINGS_LABELS": "Przejdź do ustawień etykiet",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Przejdź do ustawień gotowych odpowiedzi",
      "GO_TO_SETTINGS_APPLICATIONS": "Przejdź do ustawień aplikacji",
      "GO_TO_SETTINGS_ACCOUNT": "Przejdź do ustawień konta",
      "GO_TO_SETTINGS_PROFILE": "Przejdź do ustawień profilu",
      "GO_TO_NOTIFICATIONS": "Przejdź do powiadomień",
      "ADD_LABELS_TO_CONVERSATION": "Dodaj etykietę do rozmowy",
      "ASSIGN_AN_AGENT": "Przypisz agenta",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Przypisz priorytet",
      "ASSIGN_A_TEAM": "Przypisz zespół",
      "EXECUTE_A_MACRO": "Uruchom makro",
      "MUTE_CONVERSATION": "Wycisz rozmowę",
      "UNMUTE_CONVERSATION": "Wyłącz wyciszenie rozmowy",
      "REMOVE_LABEL_FROM_CONVERSATION": "Usuń etykietę z rozmowy",
      "REOPEN_CONVERSATION": "Ponownie otwórz rozmowę",
      "RESOLVE_CONVERSATION": "Zamknij rozmowę",
      "SEND_TRANSCRIPT": "Wyślij transkrypt rozmowy",
      "SNOOZE_CONVERSATION": "Zatrzymaj rozmowę",
      "UNTIL_NEXT_REPLY": "Do następnej odpowiedzi",
      "UNTIL_NEXT_WEEK": "Do następnego tygodnia",
      "UNTIL_TOMORROW": "Do jutra",
      "UNTIL_NEXT_MONTH": "Do następnego miesiąca",
      "AN_HOUR_FROM_NOW": "Do godziny od teraz",
      "UNTIL_CUSTOM_TIME": "Niestandardowe...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Ładowanie aplikacji pulpitu..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "kliknij tutaj"
  }
}
